import { useContext } from "react";
import { ModalTicketContext } from "../contexts/ModalTicketContext";

export function useModalTicket() {
  return useContext(ModalTicketContext);
}
